import React, { useState } from 'react';
import { useProjectModel } from '../../../model.js';
import { generateEditorReactComponent } from './generate.js';
import { useGenerationTask } from '../hooks/use-generation-task.js';
import {
  ChooseComponentDescriptionStep,
  ChooseComponentFolderStep,
  ChooseComponentNameStep,
} from './steps.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../CompleteGeneration.js';

export const useGenerateEditorReactComponent = () => {
  const {
    model: { projectFolder, config },
  } = useProjectModel();
  const [componentName, setComponentName] = useState<string>();
  const [componentFolder, setComponentFolder] = useState<string>();
  const [componentDescription, setComponentDescription] = useState<string>();

  const generationTask = useGenerationTask(async () => {
    if (componentName && componentFolder && componentDescription) {
      return generateEditorReactComponent(
        projectFolder,
        componentFolder,
        componentName,
        componentDescription,
        config.projectType === 'App' ? config.codeIdentifier : undefined
      );
    }
  }, [componentFolder, componentName, componentDescription]);

  return [
    <ChooseComponentNameStep
      onSubmit={setComponentName}
      componentName={componentName}
    />,
    <ChooseComponentFolderStep
      onSubmit={setComponentFolder}
      componentFolder={componentFolder}
      componentName={componentName}
    />,
    <ChooseComponentDescriptionStep
      onSubmit={setComponentDescription}
      componentDescription={componentDescription}
    />,
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={'editor react component'}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        learnMoreUrl:
          'https://dev.wix.com/docs/wix-cli/guides/about-the-wix-cli',
      })}
    />,
  ];
};
